import { UserRole } from "../types";

export type NavigationIcon =
  | "overview"
  | "machines"
  | "jobs"
  | "worklists"
  | "reports"
  | "licenses"
  | "customers"
  | "updates"
  | "messages"
  | "support"
  | "computers"
  | "admin"
  | "tokens"
  | "resellers"
  | "database"
  | "security";
export type NavigationSection =
  | "workspace"
  | "production"
  | "management"
  | "support"
  | "admin";
export interface NavigationItem {
  label: string;
  description: string;
  path: string;
  icon: NavigationIcon;
  section: NavigationSection;
  roles?: UserRole[];
  menu?: boolean;
  keywords?: string;
}

export const navigationSections: { id: NavigationSection; label: string }[] = [
  { id: "workspace", label: "Spazio di lavoro" },
  { id: "production", label: "Produzione" },
  { id: "management", label: "Gestione" },
  { id: "support", label: "Software e supporto" },
  { id: "admin", label: "Amministrazione" },
];
const managers: UserRole[] = ["administrator", "reseller"];
const administrators: UserRole[] = ["administrator"];
const destinations: NavigationItem[] = [
  {
    label: "Panoramica",
    description: "Stato operativo e attività recenti",
    path: "/dashboard",
    icon: "overview",
    section: "workspace",
    keywords: "dashboard home inizio",
  },
  {
    label: "Parco macchine",
    description: "Connessioni, dettagli e licenze NextControl",
    path: "/machines",
    icon: "machines",
    section: "workspace",
    keywords: "hmi cnc matricola seriale",
  },
  {
    label: "Lavorazioni",
    description: "Lavori in corso e storico dei nesting",
    path: "/jobs",
    icon: "jobs",
    section: "production",
    keywords: "taglio pezzi produzione storico",
  },
  {
    label: "Liste di lavoro",
    description: "Code e programmi da inviare alle macchine",
    path: "/worklists",
    icon: "worklists",
    section: "production",
    keywords: "pgm worklist online programmi",
  },
  {
    label: "Dati di produzione",
    description: "Tempi, utilizzo, consumi e report CSV",
    path: "/reports",
    icon: "reports",
    section: "production",
    keywords: "analisi statistiche ore report",
  },
  {
    label: "Licenze software",
    description: "Scadenze, coperture e computer autorizzati",
    path: "/licenses",
    icon: "licenses",
    section: "management",
    keywords: "nextcut nextframe nextdrill nextcloud pc postazioni attivazione",
  },
  {
    label: "NEXT Manager",
    description: "Le 10 versioni e i loro limiti di utenti e macchine",
    path: "/licenses/next-manager",
    icon: "licenses",
    section: "management",
    roles: managers,
    keywords: "licenze versioni edizioni limiti utenti macchine gestionale",
  },
  {
    label: "Clienti",
    description: "Aziende, contatti e assegnazioni",
    path: "/admin/customers",
    icon: "customers",
    section: "management",
    roles: managers,
  },
  {
    label: "Gestione macchine",
    description: "Inventario, configurazione e assegnazioni",
    path: "/machines/manage",
    icon: "machines",
    section: "management",
    roles: managers,
  },
  {
    label: "Aggiornamenti software",
    description: "Versioni e pacchetti dei prodotti Next",
    path: "/software-updates",
    icon: "updates",
    section: "support",
    keywords: "release download versioni",
  },
  {
    label: "Messaggi HMI",
    description: "Comunicazioni con gli operatori",
    path: "/messages",
    icon: "messages",
    section: "support",
  },
  {
    label: "Assistenza remota",
    description: "Collegamenti e strumenti di assistenza",
    path: "/remote-assistance",
    icon: "support",
    section: "support",
    keywords: "rustdesk supporto",
  },
  {
    label: "I miei PC",
    description: "Computer disponibili per il collegamento remoto",
    path: "/my-computers",
    icon: "computers",
    section: "support",
  },
  {
    label: "Amministrazione",
    description: "Utenti, ruoli e configurazione della piattaforma",
    path: "/admin",
    icon: "admin",
    section: "admin",
    roles: administrators,
  },
  {
    label: "Token macchine",
    description: "Codici monouso per registrare nuove macchine",
    path: "/admin/activation",
    icon: "tokens",
    section: "admin",
    roles: administrators,
    keywords: "attivazione token registrazione",
  },
  {
    label: "Aggiornamenti HMI",
    description: "Gestione delle versioni del software macchina",
    path: "/admin/hmi-updates",
    icon: "updates",
    section: "admin",
    roles: administrators,
  },
  {
    label: "Rivenditori",
    description: "Gestione dei rivenditori e delle loro aziende",
    path: "/admin/resellers",
    icon: "resellers",
    section: "admin",
    roles: administrators,
    menu: false,
    keywords: "reseller",
  },
  {
    label: "Database",
    description: "Strumenti di amministrazione del database",
    path: "/admin/database",
    icon: "database",
    section: "admin",
    roles: administrators,
    menu: false,
  },
  {
    label: "Sicurezza account",
    description: "Passkey e protezione dell’accesso",
    path: "/security",
    icon: "security",
    section: "workspace",
    menu: false,
  },
];

export const getNavigation = (role?: UserRole) =>
  role
    ? destinations.filter((item) => !item.roles || item.roles.includes(role))
    : [];
export const isNavigationActive = (item: NavigationItem, path: string) =>
  item.path === path ||
  (item.path === "/admin/customers" && path === "/reseller/clients") ||
  (item.path === "/machines" &&
    path.startsWith("/machines/") &&
    path !== "/machines/manage");
export const getPageContext = (path: string, role?: UserRole) => {
  if (path === "/reseller/clients" && role && managers.includes(role))
    return destinations.find((item) => item.path === "/admin/customers");
  return (
    getNavigation(role).find((item) => item.path === path) ||
    (path.startsWith("/machines/")
      ? { ...destinations[1], label: "Dettaglio macchina" }
      : undefined)
  );
};
export const normalizeSearch = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("it-IT")
    .trim();
export const matchesNavigationSearch = (query: string, values: string[]) => {
  const haystack = normalizeSearch(values.join(" "));
  return normalizeSearch(query)
    .split(/\s+/)
    .every((word) => haystack.includes(word));
};

/** Only restore internal application paths after authentication. */
export const getReturnPath = (state: unknown): string => {
  const value = (state as { returnTo?: unknown } | null)?.returnTo;
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    /[\\\r\n]/.test(value) ||
    /^\/(login|register|verify-email)(\/|\?|$)/.test(value)
  )
    return "/dashboard";
  return value;
};
